<template>
  <div>
    <div class="language-items text-center">
      <a href="#" v-for="(language, index) in languages" :key="index" @click="HandleChangeLang(language.code)"
        :class="selectedLang === language.code ? 'selected' : 'non-selected'">
        <img :src="getImagePath(language.src)" :alt="language.alt" />
      </a>
    </div>

  </div>
</template>
<script>
import coreLangService from '@/CommonVueCore/src/services/langService/langService'
import coreLanguageSettings from '@/CommonVueCore/src/configs/language/languageSettings.js'
export default {
  data() {
    return {
      selectedLang: coreLangService.GetSelectedLang(),
      languages: coreLanguageSettings.languages
    }
  },
  methods: {
    HandleChangeLang(_lang) {
      coreLangService.ChangeLang(_lang);
      this.selectedLang = coreLangService.GetSelectedLang();
    },
    GetSelectedLang() {
      this.selectedLang = coreLangService.GetSelectedLang();
    },
    getImagePath(imageName) {
      return require(`@/CommonVueCore/src/assets/icons/flaticon/${imageName}`);
    }
  },
  watch: {
    //farklı bir dile tıklandığında sayfa yenilemesi gerek
    selectedLang(newValue, oldValue) {
      if (newValue !== oldValue)
        document.location.reload();
    }
  },
}
</script>
<style>
.language-items img {
  width: 20px;
  border-radius: 10px;
  margin: 4px;
  transition: 0.2s ease;
}

.language-items img:hover {
  transform: scale(1.3);
  box-shadow: 2px 2px 5px 1px rgba(0, 0, 0, 0.2);
}

.language-items a {
  transition: 0.5s ease;
}

.language-items a.selected {
  opacity: 1;
}

.language-items a.non-selected {
  opacity: 0.3;
}

.language-items a:hover {
  opacity: 1;
}
</style>